// extracted by mini-css-extract-plugin
module.exports = {"root":"Carousel_root__2ZCgu","threeToTwoWrapper":"Carousel_threeToTwoWrapper__25uGT","aspectWrapper":"Carousel_aspectWrapper__fJIZ9","rootForImage":"Carousel_rootForImage__1U2kT"};